export var DataTypes;

(function (DataTypes) {
  DataTypes["notDefined"] = "not-defined";
  DataTypes["string"] = "string";
  DataTypes["number"] = "number";
  DataTypes["dateTime"] = "datetime";
  DataTypes["boolean"] = "boolean";
})(DataTypes || (DataTypes = {}));

export var DATA_TYPES = [{
  label: 'widget_customization_data_types.datetime',
  value: DataTypes.dateTime
}, {
  label: 'widget_customization_data_types.number',
  value: DataTypes.number
}, {
  label: 'widget_customization_data_types.string',
  value: DataTypes.string
}];